import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import axios from 'axios'
import { useSelector } from 'react-redux'
import {
  CreditCardListModel,
  CreditCardListResponse,
} from 'src/models/creditCard.models'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

// TODO: Figure out this type
type CreditCardV2Response = unknown

export function useGetCreditCardV2(
  creditCardId: string,
  options?: UseQueryOptions,
) {
  const authedConfig = useSelector(selectAuthedJsonApiRequestConfig)

  return useQuery<CreditCardV2Response>({
    queryKey: ['creditcardsv2', creditCardId],
    queryFn: async () => {
      const response = await axios.get(
        `/creditcardsv2/${creditCardId}`,
        authedConfig,
      )
      return response.data as CreditCardV2Response
    },
    ...options,
  })
}

/**
 * Lazy query here to grab a credit card by ID via vanilla Axios. No useQuery.
 * @returns
 */
export function useLazyGetCreditCardById() {
  const authedConfig = useSelector(selectAuthedJsonApiRequestConfig)

  return {
    getCardById: async (creditCardId: string) => {
      const response = await axios.get(
        `/creditcards/${creditCardId}`,
        authedConfig,
      )
      const creditCard = new CreditCardListModel(
        response.data.creditCard as CreditCardListResponse,
      )

      return creditCard
    },
  }
}
